// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3TXaH","name":"ConsentHeader_name__2HrL6","birthday":"ConsentHeader_birthday__1wAAE","skeleton":"ConsentHeader_skeleton__275nn"};